module.exports = __webpack_public_path__ + "media/images/client-9-e111eb3d7b8d334dd1683766ff6a5eeb.png";